import { globalHandler } from '../handlers/global_handler'

function initGlobalTrigger() {
    const triggers = document.querySelectorAll('[download-item="global-trigger"]')
    triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
            globalHandler(trigger)
        })
    })
}

export { initGlobalTrigger }
